import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage     from './pages/LoginPage';
import RegisterPage  from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import ProjectPage   from './pages/ProjectPage';
import SharedPage    from './pages/SharedPage';
import MfaSetupPage  from './pages/MfaSetupPage';

// FIX MOYEN — Vérifie présence ET expiration du token JWT
function isAuth() {
  const token = localStorage.getItem('ebios_token');
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    // Rejeter les tokens MFA temporaires (mfaPending)
    if (payload.mfaPending) return false;
    if (payload.exp && Date.now() / 1000 > payload.exp) {
      localStorage.removeItem('ebios_token');
      localStorage.removeItem('ebios_user');
      return false;
    }
    return true;
  } catch {
    localStorage.removeItem('ebios_token');
    localStorage.removeItem('ebios_user');
    return false;
  }
}

function Private({ children }) {
  return isAuth() ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login"         element={<LoginPage />} />
        <Route path="/register"      element={<RegisterPage />} />
        <Route path="/shared/:token" element={<SharedPage />} />
        <Route path="/mfa/setup"     element={<Private><MfaSetupPage /></Private>} />
        <Route path="/"              element={<Private><DashboardPage /></Private>} />
        <Route path="/project/:id"   element={<Private><ProjectPage /></Private>} />
        <Route path="*"              element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}
